.container {
  width: 390px;
  height: 48px;
  margin-inline: auto;
  background-color: var(--color-primary-blue-900);
}

.inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 8px;
}

.left {
  display: flex;
  gap: 8px;
  align-items: center;
}

.right {
  display: flex;
  gap: 8px;
  align-items: center;
}

.logo {
  width: 80px;
  height: 16px;
}

.link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  font-size: var(--font-size-xs);
  font-weight: bold;
  color: var(--color-gray-200);
}

.linkBorder {
  border: 1px solid var(--color-gray-200);
  border-radius: 2px;
}
